/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import url from 'url';

export const CmsHostMapping: string[] = ['cms-eastus-ppe-imageresizer-mr.cloudapp.net'];

export const getResizedImageUrl = (imageUrl: string, width?: number, height?: number): string | undefined => {
    const imgUrlParts = url.parse(imageUrl, true);
    const host = imgUrlParts.host;
    if (imgUrlParts && host && CmsHostMapping.indexOf(host) > -1) {
        if (width) {
            imgUrlParts.query.w = width.toString();
        }
        if (height) {
            imgUrlParts.query.h = height.toString();
        }

        imgUrlParts.query.m = '6';

        imageUrl = url.format(imgUrlParts);
    }

    return imageUrl;
};
